import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import NoFlowchartViewer from 'processes/graph-builder-processes/flowchart-viz/NoFlowchartViewer';
import ProcessTaskLineageViewer from 'processes/graph-builder-processes/flowchart-viz/ProcessTaskLineageViewer';
import {GRAY_LIGHTER} from 'ui-library/Colors';

interface MissingFlowchartProps {
  executionFlowchartId?: never;
  missingFlowchartMessage: string;
  rootTaskId?: never;
  taskId?: never;
}

export interface ProcessTaskFlowchartTabViewProps {
  executionFlowchartId: string;
  missingFlowchartMessage?: never;
  rootTaskId: string;
  taskId: string;
}

export default function ProcessTaskFlowchartTabView({
  executionFlowchartId,
  missingFlowchartMessage,
  rootTaskId,
  taskId,
}: MissingFlowchartProps | ProcessTaskFlowchartTabViewProps): JSX.Element {
  if (missingFlowchartMessage == null) {
    return (
      <div className={classNames(css(styles.tabBackground), 'react-tab-container')}>
        <ProcessTaskLineageViewer
          // @ts-expect-error This prop was spuriously present, but incorrectly passing typechecking at the
          // point in time where this tab was migrated to React. It is preserved Just In Case.
          executionFlowchartId={executionFlowchartId}
          rootTaskId={rootTaskId}
          taskId={taskId}
        />
      </div>
    );
  } else {
    return (
      <div className={classNames(css(styles.tabBackground), 'react-tab-container')}>
        <NoFlowchartViewer message={missingFlowchartMessage} />
      </div>
    );
  }
}

ProcessTaskFlowchartTabView.prototype.className = 'buffer-tab buffer-tab--no-padding';

const styles = StyleSheet.create({
  tabBackground: {
    background: GRAY_LIGHTER,
    padding: 0,
    maxHeight: '100%',
    overflow: 'hidden',
  },
});
